import { Component, Prop, h } from '@stencil/core';
// import { Size, SizeType } from '../../types';

/* const sizeValues: Record<SizeType, number> = {
  [Size.xlarge]: 48,
  [Size.large]: 36,
  [Size.medium]: 27,
  [Size.small]: 18,
  [Size.xsmall]: 12,
}; */

@Component({
  tag: 'anchor-spinner',
  styleUrl: 'spinner.scss',
  shadow: true,
})
export class Spinner {
  /**
   * We recommend controlling the size of the Spinner with the parent container. Size option included for the sake of flexibility.
   */
  @Prop() size: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';

  /**
   * You shouldn't change this from it's default but we've included the option for the sake of flexibility
   */
  @Prop() strokeWidth: number = 7;

  render() {
    const size = 48; // sizeValues[this.size] || this.size;
    const viewbox = 72;
    const radius = (viewbox - this.strokeWidth) / 2;
    const center = viewbox / 2;

    return (
      <svg class={`spinner ${this.size || ''}`} width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${viewbox} ${viewbox}`} xmlns="http://www.w3.org/2000/svg">
        <circle
          class="path colors"
          fill="none"
          stroke-width={this.strokeWidth}
          stroke-linecap="butt"
          cx={center}
          cy={center}
          r={radius}
          stroke-dasharray={2 * Math.PI * radius * (85 / 100)}
        ></circle>
      </svg>
    );
  }
}
